import { Dropdown, Nav, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import HourglassGlobals from "../../helpers/globals";
import { Permission } from "../../types/permission";
import React from "react";
import { List } from "react-bootstrap-icons";

type smpwLink = {
  sectionHeader?: string;
  title: string;
  path: string;
  show: boolean;
  postDivider: boolean;
  target?: string;
};

const links = (includeCongLinks: boolean, showDontate: boolean): smpwLink[] => [
  { sectionHeader: "", title: "list.congregation.title", path: "/", show: includeCongLinks, postDivider: true },
  { sectionHeader: "smpw.smpw", title: "smpw.my_dashboard", path: "/smpw", show: true, postDivider: false },
  {
    title: "schedules.scheduling",
    path: "/smpw/scheduling",
    show:
      HourglassGlobals.permissions.has(Permission.SMPWAdmin) ||
      HourglassGlobals.permissions.has(Permission.SMPWSchedule),
    postDivider: false,
  },
  {
    title: "smpw.admin",
    path: "/smpw/admin",
    show:
      HourglassGlobals.permissions.has(Permission.SMPWAdmin) ||
      HourglassGlobals.permissions.has(Permission.SMPWUpdateUsers),
    postDivider: true,
  },
  {
    title: "nav.help",
    path: "/smpw/docs",
    show: true,
    postDivider: false,
  },
  {
    title: "www.donate-button",
    path: "https://www.paypal.com/donate/?hosted_button_id=LEWREP6SGSV98",
    show: showDontate,
    postDivider: false,
    target: "_blank",
  },
];

export function NavSMPW(props: { className?: string }) {
  const { t } = useTranslation();

  return (
    <Nav className={props.className ?? "flex-column hg-nav"}>
      {links(false, false).map((l, i) =>
        l.show ? (
          <NavDropdown.Item key={i} as={Link} to={l.path}>
            {t(l.title)}
          </NavDropdown.Item>
        ) : (
          <React.Fragment key={i}></React.Fragment>
        ),
      )}
    </Nav>
  );
}

export function SMPWDropdown(props: { includeCongLinks: boolean; className?: string }) {
  const { t } = useTranslation();

  return (
    <Dropdown className={props.className}>
      <Dropdown.Toggle variant="secondary" id="dropdown-basic">
        <List />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {links(props.includeCongLinks, true).map((l, i) =>
          l.show ? (
            <React.Fragment key={i}>
              {!!l.sectionHeader && <Dropdown.Header>{t(l.sectionHeader)}</Dropdown.Header>}
              <Dropdown.Item as={Link} to={l.path} className="ps-4" target={l.target}>
                {t(l.title)}
              </Dropdown.Item>
              {l.postDivider && <Dropdown.Divider />}
            </React.Fragment>
          ) : (
            <React.Fragment key={`${i}_frag`}></React.Fragment>
          ),
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}
